import React from 'react';
import GenusShape from './GenusShape';
import NounWithEnding from './NounWithEnding';

const WordHeaderArticle = ({
  article,
  gender,
  className = '',
  showWord = false,
  word = '',
  endingGender,
}) => {
  if (!article) return null;

  const articleColors = {
    'der': 'var(--der)',
    'die': 'var(--die)',
    'das': 'var(--das)',
  };

  const genderColors = {
    masculine: 'var(--der)',
    feminine: 'var(--die)',
    neuter: 'var(--das)',
  };

  const normalized = article.toLowerCase();
  const genderKey = (gender || '').toLowerCase();
  const textColor = genderColors[genderKey] || articleColors[normalized] || 'var(--ink-800)';
  const endingGenderResolved = endingGender || gender || normalized;

  return (
    <span className={`${className} font-bold inline-flex items-center gap-1`} style={{ color: textColor }}>
      <GenusShape article={normalized} size={12} filled />
      {article}
      {showWord && word && (
        <span className="ml-1 font-normal">
          <NounWithEnding word={word} gender={endingGenderResolved} />
        </span>
      )}
    </span>
  );
};

export default WordHeaderArticle;
